import './SiteLocaleSelectionPopupMenu.scss';

import React, { useEffect, useState } from 'react';

import { Icon } from '../Primitives';
import { Link } from 'gatsby';
import { useCookies } from 'react-cookie';
import { useCustomerAccount } from '../../context/customerAccount/useCustomerAccount';
import {
    useGlobalLocalization,
    usePageLocalization,
} from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useCookiesConsent } from '@sbi-international/boutik.package.cookie.consent';

SiteLocaleSelectionPopupMenu.defaultProps = {
    direction: 'down',
};

// todo get it from useSiteLocale
function SiteLocaleSelectionList(props: {
    showCurrency?: boolean;
    userStore?: string;
}) {
    const { showCurrency, userStore } = props;
    const {
        localizationContext: { locales },
    } = useGlobalLocalization();
    const { currentPageAlternatives, currentLocale } = usePageLocalization();
    const isBrowser = typeof window !== 'undefined';
    let queryArgs = '';
    if (isBrowser) {
        queryArgs = window.location.search;
    }
    const [_, setCookies] = useCookies(['drolet_store']);
    
    return (
        <ul className='nav'>
            {Object.values(locales).map((locale: any) => {
                const lang = locale.langCode;
                const currentCountryCode = locale.countryCode;

                // FIXME: Déterminer la monnaie via les attributs sur le pays
                const money = currentCountryCode + 'd';

                const shouldDisplay =
                    (userStore === undefined ||
                        userStore === currentCountryCode) &&
                    locale.localeCode !== currentLocale;

                if (shouldDisplay) {
                    return (
                        <li className='locale' key={locale.localeCode}>
                            <Link
                                to={`${
                                    currentPageAlternatives[locale.localeCode]
                                }${queryArgs}`}
                                hrefLang={locale.bcp47LocaleCode}
                                onClick={() => {
                                    setCookies(
                                        'drolet_store',
                                        locale.localeCode,
                                        {
                                            path: '/',
                                        }
                                    );
                                }}
                            >
                                {showCurrency
                                    ? `${lang.toUpperCase()} | ${money.toUpperCase()}`
                                    : `${lang.toUpperCase()}`}
                            </Link>
                        </li>
                    );
                }
            })}
        </ul>
    );
}

export default function SiteLocaleSelectionPopupMenu(props: {
    showCurrency?: boolean;
    direction?: string;
}) {
    const { currentUser } = useCustomerAccount();
    const { currentLocaleDefinition, shouldDisplayLanguageSwitcher } =
        usePageLocalization();
    const lang = currentLocaleDefinition.langCode;
    const country = currentLocaleDefinition.countryCode;
    const money = country + 'd'; // FIXME: Déterminer la monnaie via les attributs sur le pays
    const [showList, setShowList] = useState<boolean>(true);

    const pathname =
        typeof window !== 'undefined' ? window.location.pathname : '';

    useEffect(() => {
        setShowList(
            currentUser?.store !== 'US' &&
                shouldDisplayLanguageSwitcher(pathname)
        );
    }, [currentUser?.store, pathname, shouldDisplayLanguageSwitcher]);

    return (
        <div
            className='localeSelection'
            style={{
                pointerEvents: shouldDisplayLanguageSwitcher(pathname)
                    ? 'auto'
                    : 'none',
            }}
        >
            <div className={`currentLocale ${showList ? 'list' : ''}`}>
                <span>
                    {props.showCurrency
                        ? `${lang.toUpperCase()} | ${money.toUpperCase()}`
                        : `${lang.toUpperCase()}`}
                </span>
                {showList && (
                    <Icon
                        className='chevronDown'
                        d='M2.5,0,5,4H0Z'
                        size='6'
                        transform='translate(5 4) rotate(180)'
                    />
                )}
            </div>
            {showList && (
                <div
                    className={
                        props.direction === 'down'
                            ? 'localesContainer'
                            : `localesContainer bottom`
                    }
                >
                    <SiteLocaleSelectionList
                        showCurrency={props.showCurrency}
                        userStore={currentUser?.store}
                    />
                </div>
            )}
        </div>
    );
}
